export default __webpack_public_path__ + "static/media/united-states-of-america.eb20a0b0.svg";